import React, { useEffect, useState } from "react";
import { Disclosure, Menu, MenuButton } from "@headlessui/react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import DesktopNav from "../components/Navbar/DesktopNav";
import MobileNav from "../components/Navbar/MobileNav";
import UserMenu from "../components/Navbar/UserMenu";
import { getNavigationByUserType } from "../constants/utils"
import api from "../api.js"
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../components/Navbar/maplms.png"
const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const [token, setToken] = useState("");
  const [user_id, setUID] = useState(0);
  const [student_id, setSID] = useState(0);
  const [email, setEmail] = useState("");
  const [userType, setUserType] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = window.localStorage.getItem("token");
    const storedUserType = window.localStorage.getItem("user_type");
    console.log(storedUserType!=1)
    if (storedToken && storedUserType && storedUserType!=1) {
      setToken(storedToken);
      setUserType(parseInt(storedUserType));
    
      const uid = window.localStorage.getItem("uid");
      const isRegister = window.localStorage.getItem("isregister");
      setIsLoggedIn(true)
      if (uid && isRegister) {
        setUID(parseInt(uid));
        const fetchEmail = async () => {
          try {
            const response = await api.post(`api/register/getemail/${uid}`);
            console.log(response.data)
            if (response.data && response.data.length > 0) {
              setEmail(response.data[0].emailid);
            }
          } catch (err) {
            console.error("Failed to fetch email:", err);
          }
        };
        fetchEmail();
      }
    }else if (storedToken && storedUserType == 1) {
      setToken(storedToken);
      setUserType(parseInt(storedUserType));

      setIsLoggedIn(true)
      const sid = window.localStorage.getItem("sid");
      console.log(sid)
      const isRegister = window.localStorage.getItem("isregister");
      if (sid && isRegister) {
        setSID(parseInt(sid));
        const fetchStudentEmail = async () => {
          try {
            const response = await api.get(`api/register/student/getemail/${sid}`);
            console.log(response.data)
            if (response.data && response.data.length > 0) {
              setEmail(response.data[0].emailid);
              console.log(email)
            }
          } catch (err) {
            console.error("Failed to fetch email:", err);
          }
        };
        fetchStudentEmail();
      }
    }
    
  }, []);
// Toggle between true and false for testing
 // Set userType (1, 2, or 3)

  // Dynamic navigation based on userType
  const navigation = getNavigationByUserType(userType);

  return (
    <header  id="header_nav">
      <Disclosure as="nav" className="g10 fixed top-0 left-0 z-50 w-full">
        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
          <div className="relative flex h-16 items-center justify-between">
            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
              <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                <span className="sr-only">Open main menu</span>
                <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
              </Disclosure.Button>
            </div>
            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              <div className="flex shrink-0 items-center">
                <img
                  className="h-8 w-auto"
                  src={logo}
                  alt="maplms"
                />
              </div>
              <DesktopNav navigation={navigation} />
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              <Menu as="div" className="relative ml-3">
                <div>
                  <MenuButton className="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="h-8 w-8 rounded-full"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt="maplms"
                    />
                  </MenuButton>
                </div>
                <UserMenu isLoggedIn={isLoggedIn} email={email}/>
              </Menu>
            </div>
          </div>
        </div>
        <MobileNav navigation={navigation} />
      </Disclosure>
    </header>
  );
};

export default Header;
